import { ServicesConfigs } from '../service.types'

const medicalReimbursementServiceConfigs: ServicesConfigs = {
  collectionName: 'MedicalReimbursements',
}

export default medicalReimbursementServiceConfigs
